import { render, staticRenderFns } from "./timeClock.vue?vue&type=template&id=18165be4&scoped=true"
import script from "./timeClock.vue?vue&type=script&lang=js"
export * from "./timeClock.vue?vue&type=script&lang=js"
import style0 from "./timeClock.vue?vue&type=style&index=0&id=18165be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18165be4",
  null
  
)

export default component.exports